export default "__VITE_ASSET__DKlG4vAP__"